import React, {
  useState
} from "react";

import GalleryCategorySuggest
  from "./GalleryCategorySuggest";

import GalleryUpload
  from "./GalleryUpload";

import GalleryMyImages
  from "./GalleryMyImages";

export default function GalleryDashboard({
  user
}) {

  const [tab, setTab] =
    useState("suggest");
	const [refreshKey, setRefreshKey] =
  useState(0);

  const activeBtn = {
    border: "none",
    padding: "12px 20px",
    borderRadius: 12,
    cursor: "pointer",
    fontWeight: 700,
    color: "#fff",
    background:
      "linear-gradient(135deg,#2563eb,#7c3aed)"
  };

  const normalBtn = {
    border: "1px solid #d1d5db",
    padding: "12px 20px",
    borderRadius: 12,
    cursor: "pointer",
    fontWeight: 700,
    background: "#fff"
  };

  return (

    <div
      style={{
        minHeight: "100vh",
        background: "#f5f7fb",
        padding: 20
      }}
    >

      <div
        style={{
          maxWidth: 1300,
          margin: "0 auto"
        }}
      >

        <div
          style={{
            background: "#fff",
            borderRadius: 24,
            padding: 24,
            boxShadow:
              "0 10px 35px rgba(0,0,0,.08)"
          }}
        >

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 15,
              flexWrap: "wrap",
              marginBottom: 25
            }}
          >

            {user?.photoURL && (

              <img
                src={
                  user.photoURL
                }
                alt=""
                style={{
                  width: 70,
                  height: 70,
                  borderRadius:
                    "50%",
                  objectFit:
                    "cover"
                }}
              />

            )}

            <div>

              <h1
                style={{
                  margin: 0
                }}
              >
                PITICS Gallery Dashboard
              </h1>

              <div
                style={{
                  color:
                    "#6b7280",
                  marginTop: 5
                }}
              >
                Gallery Content Management Console
              </div>

            </div>

          </div>

          <div
            style={{
              background:
                "#eff6ff",
              border:
                "1px solid #bfdbfe",
              padding: 16,
              borderRadius: 14,
              marginBottom: 24
            }}
          >

            <strong>
              Account Status:
            </strong>{" "}
            Approved Content Contributor

          </div>

          <div
            style={{
              display: "flex",
              gap: 10,
              flexWrap: "wrap",
              marginBottom: 25
            }}
          >

            <button
              style={
                tab === "suggest"
                  ? activeBtn
                  : normalBtn
              }
              onClick={() =>
                setTab(
                  "suggest"
                )
              }
            >
              Suggest Categories
            </button>

            <button
              style={
                tab === "upload"
                  ? activeBtn
                  : normalBtn
              }
              onClick={() =>
                setTab(
                  "upload"
                )
              }
            >
              Upload Content
            </button>

            <button
              style={
                tab === "images"
                  ? activeBtn
                  : normalBtn
              }
              onClick={() =>
                setTab(
                  "images"
                )
              }
            >
              My Uploads
            </button>

          </div>

         {tab === "suggest" && (

  <GalleryCategorySuggest
    user={user}
    onSubmitted={() =>
      setRefreshKey(
        prev => prev + 1
      )
    }
  />

)}

         {tab === "upload" && (

  <GalleryUpload
    key={refreshKey}
    user={user}
  />

)}

          {tab === "images" && (

            <GalleryMyImages
              user={user}
            />

          )}

        </div>

      </div>

    </div>

  );

}
